import { render, staticRenderFns } from "./Medias.vue?vue&type=template&id=20718f12&"
import script from "./Medias.vue?vue&type=script&lang=js&"
export * from "./Medias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports